/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconInfoCircle(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 1.237a6.762 6.762 0 1 0 0 13.525A6.762 6.762 0 0 0 8 1.237m.942 11.946H7.084V6.259h1.858zM8 2.817q.537 0 .838.275.3.263.3.734 0 .458-.314.732-.3.275-.824.275-.537 0-.838-.262-.3-.261-.3-.745 0-.445.3-.72.315-.288.838-.289"
      />
    </svg>
  );
}
